import * as React from "react";
import * as styles from "source/app/presentation/MainPanel/Goals/ClearGoals/ClearGoals.css";
import {
    defaultGoalFilterState,
    GoalsContainer,
} from "source/app/presentation/MainPanel/Goals/GoalsContainer";
import { IGoalsContainerState } from "source/app/presentation/MainPanel/Goals/IGoalsState";
import { ILogState } from "source/app/presentation/MainPanel/Log/ILogState";
import {
    defaultLogInputFormState,
    ILogInputFormState,
    IsFilterGoalCardsSwitchEnabled,
} from "source/app/presentation/MainPanel/Log/LogInputForm/LogInputForm";
import { defaultLogInputValuesState } from "source/app/presentation/MainPanel/Log/LogInputForm/LogInputFormHelpers";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { RenderDiv } from "source/app/presentation/Shared/Render";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import HowlAudioProvider from "source/app/services/Sound/AudioProvider/HowlAudioProvider";
import { GetLogEntrySound } from "source/app/services/Sound/Helpers/GetLogEntrySound";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export function RemoveFiltersLink({
    goalsContainer,
}: {
    goalsContainer: GoalsContainer;
}) {
    const [isVisible, setIsVisible] = React.useState(true);

    React.useEffect(() => {
        const shouldDisplay =
            !IsFilterGoalCardsSwitchEnabled() ||
            goalsContainer.props.searchText !== "" ||
            goalsContainer.props.clickedGoalId !== undefined ||
            goalsContainer.state.selectedDirection !==
                defaultGoalFilterState.selectedDirection;

        setIsVisible(shouldDisplay);
    });

    return (
        <RenderDiv
            id="ClearFilters"
            when={isVisible}
            withClasses={styles.clearLink}
        >
            <IconWithText
                iconSuffix={EGlyphicon.trash}
                whenClicked={() => {
                    ClearGoalsForm();
                    var logEntrySoundFile = GetLogEntrySound();
                    logEntrySoundFile.FadeOut(0, 1000);
                }}
                displayAsBlock={true}
            >
                remove filters
            </IconWithText>
        </RenderDiv>
    );
}

export function ClearGoalsForm() {
    const goalsContainer = State.ReadClass<IGoalsContainerState>(
        ESharedComponent.GoalsContainer
    );

    if (goalsContainer) {
        goalsContainer.setState(defaultGoalFilterState);
    }

    const log = State.ReadClass<ILogState>(ESharedComponent.Log);

    if (log) {
        log.setState(defaultLogInputValuesState);
    }

    const logInputForm = State.ReadClass<ILogInputFormState>(
        ESharedComponent.LogInputForm
    );

    if (logInputForm) {
        logInputForm.setState({
            filterGoalCards: defaultLogInputFormState.filterGoalCards,
        });
    }
}
